<template>
    <v-container full>
        <v-row>
            <v-col>
                <v-card :disabled="loading" :loading="loading">
                    <v-card-title>
                        Xperience's Credits used by user
                        <v-spacer />
                        <v-btn v-if="credits" outlined prepend-icon="mdi-cloud-download" @click="downloadData()">
                            Download data
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <Customer v-model="user"/>
                            </v-col>
                            <v-col>
                                <v-menu
                                    ref="rangeMenu"
                                    v-model="rangeMenu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="range"
                                            label="Date Range"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                        <v-date-picker
                                            v-model="range"
                                            no-title
                                            scrollable
                                            range
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="rangeMenu = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.rangeMenu.save(date)">OK</v-btn>
                                        </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn outlined color="accent" @click="generate">Generate</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="credits">
            <v-col>
                <v-data-table
                    :items="credits"
                    :headers="headers"
                >
                    <template #[`item.date`]="{item}">
                        {{ moment(item.date).format('DD.MM.YYYY') }}
                    </template>
                    <template #[`item.hour`]="{item}">
                        {{ moment(`${moment(item.date).format('DD.MM.YYYY')} ${item.start_hour}`).format('HH:mm') }} - 
                        {{ moment(`${moment(item.date).format('DD.MM.YYYY')} ${item.end_hour}`).format('HH:mm') }}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import NewApiService from "@/utils/new.api.service";
import moment from 'moment'
import fr from 'moment/locale/fr'
import Customer from "../../components/forms/autocomplete/Customer.vue";
moment.updateLocale('fr', fr)

export default {
    components: { Customer },
    data: () => ({
        rangeMenu: null,
        range:null,
        fitter: null,
        download:0,
        loading:false,
        credits: null,
        error: null,
        headers: [
            {text: '#Order', value: 'order_id'},
            {text: 'Date', value: 'date'},
            {text: 'Hours', value: 'hour'},
            {text: 'Bay', value: 'bays'},
        ],
    }),
    methods: {
        moment,
        generate() {
            this.loading = true;
            this.credits = null
            this.request()
                .then(({credits}) => {
                    this.credits = credits
                })
                .finally(() => {
                    this.loading=false
                })
        },
        downloadData () {
            this.download=1
            this.request()
                .then((data) => {
                    this.forceFileDownload(data)
                })
                .finally(() => {
                    this.download=0
                })
        },
        request() {
            return new Promise((resolve, reject) => {
                NewApiService.get(`admin/reporting/credits-by-user`, {
                    range: this.range,
                    user: this.user,
                    download: this.download
                })
                    .then(({ data }) => {
                        resolve(data)
                    })
                    .catch(({ response }) => {
                        this.error = response.data.message
                        reject(response)
                    })
            })
        },
        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", 'credit_by_user.csv'); //or any other extension
            document.body.appendChild(link);
            link.click();
        }
    }
}
</script>